import React from 'react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { Col } from 'bootstrap-4-react';
import VacancyPage from '../../Careers/Careers';
import Header from "../../Header/Header"

class Vacancy extends React.Component {
    constructor(props) {
        super(props);
        
    }
    
    render() {
        let vacancy_location = '';
        if (this.props.location) {
            vacancy_location = <div className="vacancy-info">
                <i className="fa fa-map-marker"></i>
                <span>{this.props.location}</span>
            </div>
        }
        
        let vacancy_type = '';
        if (this.props.type) {
            vacancy_type = <div className="vacancy-info">
                <i className="fa fa-clock-o"></i>
                <span>{this.props.type}</span>
            </div>
        }
        // let vacancy_deadline = '';
        // if (this.props.date) {
        //     vacancy_deadline =  <div className="vacancy-info">
        //         <i className="fa fa-calendar"></i>
        //         <span>{this.props.date}</span>
        //     </div>
        // }
       return (
        <Col col="md-6 12">
            <div className="vacancy">
                <h4>{this.props.title}</h4>
                {vacancy_location}
                {vacancy_type}
                {/* {vacancy_deadline} */}
                <Link  to={"/vacancyPage/" + this.props.careerId}>Apply Here</Link>
            </div>
        </Col>
       );
    }
}
export default Vacancy;
